<script>
  import rosterStore from "./Players/player-store.js";
  import { onMount } from "svelte";
  import PlayerGrid from "./Players/PlayerGrid.svelte";
  import Spinner from "./UI/Spinner.svelte";
  import playerPhotos from "./config/photomap.js";
  import team from "./config/teams.js";

  let nhlTeamId = team.id;
  let nhlTeamName = team.name;
  let dynamicTitle = nhlTeamName;

  let promise;
  let players = [];
  let isFav = false;

  const isFavStorage = window.localStorage;

  onMount(() => {
    promise = getPlayers();
  });

  async function getPlayers() {
    const res = await fetch(
      `https://statsapi.web.nhl.com/api/v1/teams/${nhlTeamId}/roster`
    );
    const data = await res.json();

    if (res.ok) {
      players = [...data.roster];

      players.map(player => {
        const playerId = player.person.id;
        const photoId = getPhotoId(playerId);
        player.person.photoId = photoId;

        const playerName = player.person.fullName.split(" ");
        player.person.firstName = playerName[0];
        player.person.lastName = playerName[1];

        const playerPositionName =
          player.position.code === "D"
            ? (player.position.name = "DEFENSE")
            : player.position.name;
        player.position.name = playerPositionName;

        player.isFavorite = isFavStorage.getItem(playerId)
          ? JSON.parse(isFavStorage.getItem(playerId))
          : (player.isFavorite = false);
      });

      // OPTIONAL: Coder Card
      // const coder = {
      //   person: {
      //     id: 1,
      //     fullName: "Brian Steele",
      //     firstName: "Brian",
      //     lastName: "Steele",
      //     photoId: 1
      //   },
      //   jerseyNumber: "00",
      //   position: {
      //     name: "Coder"
      //   },
      //   isFavorite: true
      // };
      // players.push(coder);

      rosterStore.set(players);

      return players;
    } else {
      throw new Error(`Toronto, we have a problem. Sorry.`);
    }
  }

  function getPhotoId(playerId) {
    const photo = playerPhotos.find(
      ({ nhlPlayerId }) => nhlPlayerId === playerId
    );
    if (photo) {
      return photo.nhlpaPhotoId;
    }
  }
</script>

<style global lang="scss">
  @import "./style/theme-config.scss";

  .container {
    width: 100%;
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;

    @media (min-width: 576px) {
      max-width: 540px;
    }

    @media (min-width: 768px) {
      max-width: 720px;
    }

    @media (min-width: 992px) {
      max-width: 960px;
    }

    @media (min-width: 1200px) {
      max-width: 1140px;
    }
  }

  .page-wrapper {
    padding: 1rem 0 4rem;
  }

  .error {
    color: red;
  }
</style>

<svelte:head>
  <title>{dynamicTitle}</title>
</svelte:head>

<main>
  <div class="page-wrapper">
    <div class="container">
      {#await promise}
        <Spinner />
      {:then players}
        {#if players}
          <PlayerGrid />
        {/if}
      {:catch error}
        <h2 class="error">{error.message}</h2>
      {/await}
    </div>
  </div>
</main>
